<template>
  <div class="tableWithPage">
    <div class="table">
      <t-table row-key="index" :columns="columns || []" :data="data || []" :hover="true"/>
    </div>
    <div class="pagination">
      <t-pagination :total="total" :showPageSize="false" :pageSize="pageSize" 
        @change="onChangePage" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      default: null
    },

    data: {
      type: Array,
      default: null
    },

    total: {
      type: Number,
      default: 0
    },

    pageSize: {
      type: Number,
      default: 20
    },

    layout: {
      type: String,
      default: "fixed"
    }
  },

  methods: {
    onChangePage(pageInfo) {
      console.log(pageInfo);
      this.$emit('changePage', pageInfo.current);
    }
  }
}
</script>

<style lang="scss">
.tableWithPage{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .table {
    height: calc(100% - 48px);
    overflow: auto;
  }
  .pagination{
    // height: max-content;
    height: 48px;
  }
}
</style>